import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  PlusCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Tabs,
  Card,
  Row,
  Col,
  Tag,
  Popover,
  Tooltip,
  Button,
  Avatar,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import GetSubunitsApi from "../../api/GetSubunitsApi";
import GetUnitApi from "../../api/GetUnitApi";
import GetUnitPositionsApi from "../../api/units/GetUnitPositionsApi";
import RemoveUnitHeadApi from "../../api/units/RemoveUnitHeadApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddEditUnitHeadModal from "../../components/modal/add/AddEditUnitHeadModal";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import EditUnitNameModal from "../../components/modal/edit/EditUnitNameModal";
import PageLoader from "../../components/sub/PageLoader";
import SubUnitsTable from "../../components/tables/SubUnitsTable";
import UnitPositionsTable from "../../components/tables/UnitPositionsTable";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

const { TabPane } = Tabs;

function SingleUnit() {
  const [editModal, setEditModal] = useState(false);
  const [unitData, setUnitData] = useState();
  const [subunits, setSubunits] = useState([]);
  const [subunitsData, setSubunitsData] = useState();
  const [subunitsLoading, setSubunitsLoading] = useState(false);
  const [positions, setPositions] = useState([]);
  const [positionsData, setPositionsData] = useState();
  const [positionsLoading, setPositionsLoading] = useState(false);
  const [addEditHeadModal, setAddEditHeadModal] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [removeUnitHeadModal, setRemoveUnitHeadModal] = useState(false);
  const [unitId, setUnitId] = useState("");
  const proHeight = document.body.clientHeight;
  let curLocation = useLocation();
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );

  useEffect(() => {
    getUnitData();
  }, [curLocation]);

  async function getUnitData() {
    setPageLoading(true);
    let path = curLocation.pathname;
    let id = path.split("/unit/");
    const apiResponse = await GetUnitApi(id[1]);
    if (apiResponse.message === "success") {
      setUnitData(apiResponse.unit);
      getSubunitsData(apiResponse.unit?.id, 1);
      getPositionsData(apiResponse.unit?.id, 1);
    }
    setPageLoading(false);
  }

  async function getSubunitsData(id, num) {
    setSubunitsLoading(true);
    const apiResponse = await GetSubunitsApi(id, num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setSubunits(apiResponse.data?.subUnits);
      setSubunitsData(apiResponse.data);
      setSubunitsLoading(false);
    }
  }

  async function getPositionsData(id, num) {
    setPositionsLoading(true);
    const apiResponse = await GetUnitPositionsApi(id, num, LIMIT_PER_PAGE);
    if (apiResponse.error === "Unauthorized") {
      openNotificationSuccess("bottomRight", apiResponse.message);
    }
    if (apiResponse.success) {
      setPositions(apiResponse.data?.positions);
      setPositionsData(apiResponse.data);
      setPositionsLoading(false);
    }
  }
  async function removeUnitHead() {
    const apiResponse = await RemoveUnitHeadApi(unitId);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message) {
      openNotificationSuccess("bottomRight", "Unit head removed");
      getUnitData();
    } else {
      openNotificationError("bottomRight", "Couldn't remove. Try again later.");
    }
    setUnitId("");
  }

  const right = (
    <>
      {permissionAbility(userLevel, "units", "edit") && unitData && (
        <Tooltip title={"Edit name"}>
          <Button onClick={() => setEditModal(true)} className="mr-3">
            <EditOutlined />
          </Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <>
      <div className="flex items-baseline">
        <Link
          to={
            setupAccountState
              ? "/settings/organization"
              : "/setup-account/organization"
          }
        >
          <div className="text-sm pri-font text-gray-400 hover:text-gray-500">
            Organization
          </div>
        </Link>
        <div className="mx-1 text-lg">/</div>
        <div className="text-lg pri-font">{unitData?.name || "..."}</div>
      </div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {!pageLoading ? (
            <>
              <Card style={{ borderColor: "#e5e7eb", marginBottom: "24px" }}>
                <Row>
                  <Col span={6}>
                    <div className="text-xs">Unit name</div>
                    <div>{unitData?.name}</div>
                  </Col>
                  <Col span={6}>
                    <div className="text-xs">Level</div>
                    <Tag color={unitData?.organizationLevel?.color}>
                      {unitData?.organizationLevel?.name.toUpperCase()}
                    </Tag>
                  </Col>
                  <Col span={6}>
                    <div className="text-xs">Head unit</div>
                    {unitData?.headUnit?.name ? (
                      <div className="flex items-center">
                        <div
                          className="w-2 h-2 mr-1 rounded-full"
                          style={{
                            backgroundColor: unitData?.headUnit?.level?.color,
                          }}
                        />
                        <div>{unitData?.headUnit?.name}</div>
                        <Popover
                          placement="top"
                          content={
                            <div className="text-xs">
                              {unitData?.name +
                                " < " +
                                unitData?.headUnit?.name}
                              {unitData?.headUnit?.headUnit &&
                                " < " + unitData?.headUnit?.headUnit?.name}
                            </div>
                          }
                          trigger="hover"
                        >
                          <div className="text-gray-500 text-xs ml-1">
                            <InfoCircleOutlined />
                          </div>
                        </Popover>
                      </div>
                    ) : (
                      <div>-</div>
                    )}
                  </Col>
                  <Col span={6}>
                    <div className="text-xs">Unit head</div>
                    {unitData?.unitHead ? (
                      <div className="flex items-start">
                        <div className="flex items-center gap-1 mr-1">
                          <div>
                            {unitData?.unitHead?.user?.imageUrl ? (
                              <Avatar
                                src={unitData?.unitHead?.user?.imageUrl}
                              />
                            ) : (
                              <Avatar>
                                {unitData?.unitHead?.user?.firstName ? (
                                  unitData?.unitHead?.user?.firstName
                                    ?.charAt(0)
                                    .toUpperCase()
                                ) : (
                                  <UserOutlined />
                                )}
                              </Avatar>
                            )}
                          </div>
                          <div>
                            <div>
                              {unitData?.unitHead?.user?.firstName
                                ? unitData?.unitHead?.user?.firstName +
                                  " " +
                                  unitData?.unitHead?.user?.lastName
                                : "-"}
                            </div>
                            <div className="text-xs">
                              {unitData?.unitHead?.designation?.abbreviation}
                            </div>
                          </div>
                        </div>

                        {permissionAbility(
                          userLevel,
                          "organization",
                          "delete"
                        ) && (
                          <Tooltip title={"Remove unit head"}>
                            <div
                              onClick={(event) => {
                                event.stopPropagation();
                                setUnitId(unitData?.id);
                                setRemoveUnitHeadModal(true);
                              }}
                              className="text-red-500 hover:text-red-600 cursor-pointer mt-1 text-xs"
                            >
                              <DeleteOutlined />
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    ) : (
                      permissionAbility(userLevel, "units", "add") && (
                        <Tooltip title={"Add unit head"}>
                          <div
                            onClick={() => setAddEditHeadModal(true)}
                            className="text-blue-500 hover:text-blue-600 cursor-pointer inline"
                          >
                            <PlusCircleOutlined />
                          </div>
                        </Tooltip>
                      )
                    )}
                  </Col>
                </Row>
              </Card>
            </>
          ) : (
            <PageLoader />
          )}
          <Tabs defaultActiveKey="1">
            <TabPane
              tab={`Sub units (${subunitsData?.totalCount || "0"})`}
              key="1"
            >
              <SubUnitsTable
                changePage={(num) => getSubunitsData(unitData.id, num)}
                data={subunitsData}
                subunits={subunits}
                loading={subunitsLoading}
              />
            </TabPane>
            <TabPane
              tab={`Positions (${positionsData?.totalCount || "0"})`}
              key="2"
            >
              <UnitPositionsTable
                changePage={(num) => getPositionsData(unitData.id, num)}
                data={positionsData}
                positions={positions}
                loading={positionsLoading}
              />
            </TabPane>
          </Tabs>
        </div>
      </Content>
      <EditUnitNameModal
        visible={editModal}
        handleCancel={() => setEditModal(false)}
        unit={unitData}
        handleOk={() => getUnitData()}
      />
      <AddEditUnitHeadModal
        visible={addEditHeadModal}
        unit={unitData}
        handleCancel={() => setAddEditHeadModal(false)}
        handleOk={() => getUnitData()}
      />
      <ConfirmationModal
        visible={removeUnitHeadModal}
        handleCancel={() => {
          setRemoveUnitHeadModal(false);
          setUnitId("");
        }}
        handleOk={() => removeUnitHead()}
        text="Are you sure want to remove this unit head?"
        title="Remove unit head"
      />
    </>
  );
}

export default SingleUnit;
